module.exports = __webpack_public_path__ + "static/media/Company.1cad91a8.svg";